export default __webpack_public_path__ + "static/media/youtube.7466bf0a.svg";